export default [
  {
    path: '/',
    name: 'index',
    meta: {tab: false},
    // component: Index,
    component: () => import('../components/layout/Layout.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        meta: {
          title: '首页',
          tab: true,
          keepAlive: true,
          keepAliveList: [],
          hideHeader: true,
        },
        component: () => import('../views/home/Home.vue'),
      },
      {
        path: '/recommend-config/view',
        name: 'RecommendConfigViewList',
        meta: {
          title: '推荐值配置',
          tab: true,
          keepAlive: true,
          keepAliveList: []
        },
        component: () => import('../views/recommend-config/ViewList.vue'),
      },
      {
        path: '/recommend-config/add',
        name: 'RecommendConfigAdd',
        meta: {
          title: '新增推荐值配置',
          tab: true,
          keepAlive: true,
          keepAliveList: []
        },
        component: () => import('../views/recommend-config/Add.vue'),
      },
      {
        path: '/recommend-manage/list',
        name: 'RecommendManageList',
        meta: {
          title: '推荐值管理',
          tab: true,
          keepAlive: true,
          keepAliveList: []
        },
        component: () => import('../views/recommend-manage/List.vue'),
      },
      {
        path: '/algo/list',
        name: 'AlgoList',
        meta: {
          title: '算法配置',
          tab: true,
          keepAlive: true,
          keepAliveList: []
        },
        component: () => import('../views/algo/List.vue'),
      },
      {
        path: '/workload-manage/list',
        name: 'WorkloadManageList',
        meta: {
          title: '劳动量管理',
          tab: true,
          keepAlive: true,
          keepAliveList: []
        },
        component: () => import('../views/workload-manage/List.vue'),
      },
      {
        path: '/bmi-manage/list',
        name: 'BmiManageList',
        meta: {
          title: 'BMI管理',
          tab: true,
          keepAlive: true,
          keepAliveList: []
        },
        component: () => import('../views/bmi-manage/List.vue'),
      },
      {
        path: '/geo/list',
        name: 'GeoList',
        meta: {
          title: '区域管理',
          tab: true,
          keepAlive: true,
          keepAliveList: []
        },
        component: () => import('../views/geo/List.vue'),
      },
      {
        path: '/stat/center',
        name: 'StatCenter',
        meta: {
          title: '数据中心',
          tab: true,
          keepAlive: true,
          keepAliveList: []
        },
        component: () => import('../views/stat/StatCenter'),
      },
      {
        path: '/stat/device',
        name: 'StatDevice',
        meta: {
          title: '智能单位',
          tab: true,
          keepAlive: true,
          keepAliveList: []
        },
        component: () => import('../views/stat/StatDevice'),
      },
      {
        path: '/user/list',
        name: 'UserList',
        meta: {
          title: '用户列表',
          tab: true,
          keepAlive: true,
          keepAliveList: []
        },
        component: () => import('../views/user/List'),
      },
      {
        path: '/user/detail',
        name: 'UserDetail',
        meta: {
          title: '查看用户',
          tab: true,
          keepAlive: true,
          keepAliveList: []
        },
        component: () => import('../views/user/Detail'),
      },
      {
        path: '/user/fans',
        name: 'UserFans',
        meta: {
          title: '我的粉丝',
        },
        component: () => import('../views/user/Fans'),
      },
      {
        path: '/user/follow',
        name: 'UserFollow',
        meta: {
          title: '我的关注',
        },
        component: () => import('../views/user/Follow'),
      },
      {
        path: '/user/recipe',
        name: 'UserRecipe',
        meta: {
          title: '我的菜谱',
        },
        component: () => import('../views/user/Recipe'),
      },
      {
        path: '/user/recipe-record',
        name: 'UserRecipeRecord',
        meta: {
          title: '菜谱记录',
        },
        component: () => import('../views/user/RecipeRecord'),
      },
      {
        path: '/user/dynamic',
        name: 'UserDynamicList',
        meta: {
          title: '我的动态',
        },
        component: () => import('../views/user/DynamicList'),
      },
      {
        path: '/user/deal',
        name: 'UserDealList',
        meta: {
          title: '我的交易',
        },
        component: () => import('../views/user/DealList'),
      },
      {
        path: '/user/comment',
        name: 'UserCommentList',
        meta: {
          title: '我的评论',
        },
        component: () => import('../views/user/CommentList'),
      },
      {
        path: '/user/collect',
        name: 'UserCollectList',
        meta: {
          title: '我的收藏',
        },
        component: () => import('../views/user/CollectList'),
      },
      {
        path: '/user/edit',
        name: 'UserEdit',
        meta: {
          title: '编辑用户',
        },
        component: () => import('../views/user/Edit'),
      },
      {
        path: '/virtual-user/list',
        name: 'VirtualUserList',
        meta: {
          title: '虚拟用户管理',
        },
        component: () => import('../views/virtual-user/List'),
      },
      {
        path: '/auth/list',
        name: 'AuthList',
        meta: {
          title: '创作者认证列表',
        },
        component: () => import('../views/auth/List'),
      },
      {
        path: '/auth/detail',
        name: 'AuthDetail',
        meta: {
          title: '创作者认证',
        },
        component: () => import('../views/auth/Detail.vue'),
      },
      {
        path: '/auth/audit',
        name: 'AuthAudit',
        meta: {
          title: '创作者认证',
        },
        component: () => import('../views/auth/Audit.vue'),
      },
      {
        path: '/recipe-auth/list',
        name: 'RecipeAuthList',
        meta: {
          title: '收费菜谱认证列表',
        },
        component: () => import('../views/recipe-auth/List'),
      },
      {
        path: '/recipe-auth/detail',
        name: 'RecipeAuthDetail',
        meta: {
          title: '收费菜谱认证',
        },
        component: () => import('../views/recipe-auth/Detail.vue'),
      },
      {
        path: '/recipe-auth/audit',
        name: 'RecipeAuthAudit',
        meta: {
          title: '收费菜谱认证',
        },
        component: () => import('../views/recipe-auth/Audit.vue'),
      },
      {
        path: '/recipe/list',
        name: 'RecipeList',
        meta: {
          title: '菜谱列表',
          keepAlive: true,
          keepAliveList: ["RecipeDetail", "RecipeCmtList", "IncomeList"]
        },
        component: () => import('../views/recipe/List'),
      },
      {
        path: '/recipe/detail',
        name: 'RecipeDetail',
        meta: {
          title: '查看菜谱',
        },
        component: () => import('../views/recipe/Detail'),
      },
      {
        path: '/recipe-cmt/list',
        name: 'RecipeCmtList',
        meta: {
          title: '菜谱评论',
        },
        component: () => import('../views/recipe-cmt/List'),
      },
      {
        path: '/income/list',
        name: 'IncomeList',
        meta: {
          title: '收入记录',
        },
        component: () => import('../views/income/List'),
      },
      {
        path: '/similar-recipe/list',
        name: 'SimilarRecipeList',
        meta: {
          title: '查看菜谱相似列表',
        },
        component: () => import('../views/similar-recipe/List'),
      },
      {
        path: '/recipe-category/list',
        name: 'RecipeCategoryList',
        meta: {
          title: '菜谱类目',
        },
        component: () => import('../views/recipe-category/List'),
      },
      {
        path: '/recipe-category/showCategory',
        name: 'ShowCategory',
        meta: {
          title: '菜谱类目—显示页面',
        },
        component: () => import('../views/recipe-category/ShowCategory'),
      },
      {
        path: '/recipe-category/searchType',
        name: 'SearchType',
        meta: {
          title: '搜索类型',
        },
        component: () => import('../views/recipe-category/SearchType'),
      },
      {
        path: '/food-heal/list',
        name: 'FoodHealList',
        meta: {
          title: '食物理疗',
        },
        component: () => import('../views/food-heal/List'),
      },
      {
        path: '/make-tool/list',
        name: 'MakeToolList',
        meta: {
          title: '制作工具',
        },
        component: () => import('../views/make-tool/List'),
      },
      {
        path: '/cook-taste/list',
        name: 'CookTasteList',
        meta: {
          title: '烹饪口味',
        },
        component: () => import('../views/cook-taste/List'),
      },
      {
        path: '/make-level/list',
        name: 'MakeLevelList',
        meta: {
          title: '制作难度',
        },
        component: () => import('../views/make-level/List'),
      },
      {
        path: '/make-time/list',
        name: 'MakeTimeList',
        meta: {
          title: '制作时长',
        },
        component: () => import('../views/make-time/List'),
      },
      {
        path: '/more-category/list',
        name: 'MoreCategoryList',
        meta: {
          title: '更多分类',
        },
        component: () => import('../views/more-category/List'),
      },
      {
        path: '/food/list',
        name: 'FoodList',
        meta: {
          title: '食材列表',
        },
        component: () => import('../views/food/List'),
      },
      {
        path: '/ai-food/list',
        name: 'AiFoodList',
        meta: {
          title: 'AI食材列表',
        },
        component: () => import('../views/ai-food/List'),
      },
      {
        path: '/food/detail/:code',
        name: 'FoodDetail',
        meta: {
          title: '二级食材分类',
        },
        component: () => import('../views/food/Detail'),
      },
      {
        path: '/food/addEl',
        name: 'AddFoodEl',
        meta: {
          title: '添加元素',
        },
        component: () => import('../views/food/AddFoodEl'),
      },
      {
        path: '/food/el-manage',
        name: 'ElManageList',
        meta: {
          title: '元素表管理',
        },
        component: () => import('../views/food/ElManage'),
      },
      {
        path: '/user-food/list',
        name: 'UserFoodList',
        meta: {
          title: '用户自建食材',
        },
        component: () => import('../views/user-food/List'),
      },
      {
        path: '/topic/list',
        name: 'TopicList',
        meta: {
          title: '话题列表',
        },
        component: () => import('../views/topic/List'),
      },
      {
        path: '/topic/detail',
        name: 'TopicDetail',
        meta: {
          title: '话题详情',
        },
        component: () => import('../views/topic/Detail'),
      },
      {
        path: '/topic/dynamic',
        name: 'TopicDynamic',
        meta: {
          title: '话题动态',
        },
        component: () => import('../views/topic/TopicDynamic'),
      },
      {
        path: '/dynamic/list',
        name: 'DynamicList',
        meta: {
          title: '动态列表',
        },
        component: () => import('../views/dynamic/List'),
      },
      {
        path: '/dynamic/edit',
        name: 'DynamicEdit',
        meta: {
          title: '编辑动态',
        },
        component: () => import('../views/dynamic/Edit'),
      },
      {
        path: '/dynamic/detail',
        name: 'DynamicDetail',
        meta: {
          title: '动态详情',
        },
        component: () => import('../views/dynamic/Detail'),
      },
      {
        path: '/comment/list',
        name: 'CommentList',
        meta: {
          title: '评论管理',
        },
        component: () => import('../views/comment/List'),
      },
      {
        path: '/order/list',
        name: 'OrderList',
        meta: {
          title: '交易列表',
        },
        component: () => import('../views/order/List'),
      },
      {
        path: '/withdrawal-amount/list',
        name: 'WithdrawalAmountList',
        meta: {
          title: '提现列表',
          keepAlive: true,
        },
        component: () => import('../views/withdrawal-amount/List'),
      },
      {
        path: '/member/list',
        name: 'MemberList',
        meta: {
          title: '会员套餐',
        },
        component: () => import('../views/member/List'),
      },
      {
        path: '/member-level/list',
        name: 'MemberLevelList',
        meta: {
          title: '会员等级管理',
        },
        component: () => import('../views/member-level/List'),
      },
      {
        path: '/member-level/add',
        name: 'MemberLevelAdd',
        meta: {
          title: '新增会员等级管理',
        },
        component: () => import('../views/member-level/Add'),
      },
      {
        path: '/member-level/edit',
        name: 'MemberLevelEdit',
        meta: {
          title: '编辑会员等级管理',
        },
        component: () => import('../views/member-level/Edit'),
      },
      {
        path: '/member-level/detail',
        name: 'MemberLevelDetail',
        meta: {
          title: '查看会员等级管理',
        },
        component: () => import('../views/member-level/Detail'),
      },
      {
        path: '/user-level/list',
        name: 'UserLevelList',
        meta: {
          title: '使用者会员等级管理',
        },
        component: () => import('../views/user-level/List'),
      },
      {
        path: '/user-level/record',
        name: 'UserLevelRecord',
        meta: {
          title: '使用食谱等级记录',
        },
        component: () => import('../views/user-level/UserLevelRecord'),
      },
      {
        path: '/release-level/list',
        name: 'ReleaseLevelList',
        meta: {
          title: '发布者会员等级管理',
        },
        component: () => import('../views/release-level/List'),
      },
      {
        path: '/release-level/record',
        name: 'ReleaseRecordList',
        meta: {
          title: '发布菜谱等级记录',
        },
        component: () => import('../views/release-level/Record'),
      },
      {
        path: '/integral/list',
        name: 'IntegralList',
        meta: {
          title: '积分排名',
        },
        component: () => import('../views/integral/List'),
      },
      {
        path: '/active-code/list',
        name: 'ActiveCodeList',
        meta: {
          title: '激活码列表',
        },
        component: () => import('../views/active-code/List'),
      },
      {
        path: '/active-code/detail',
        name: 'ActiveCodeDetail',
        meta: {
          title: '激活码详情',
        },
        component: () => import('../views/active-code/Detail'),
      },
      {
        path: '/active-code/statusList',
        name: 'ActiveStatusList',
        meta: {
          title: '激活码状态查询器',
        },
        component: () => import('../views/active-code/ActiveStatusList'),
      },
      {
        path: '/banner/list',
        name: 'BannerList',
        meta: {
          title: '轮播图列表',
        },
        component: () => import('../views/banner/List'),
      },
      {
        path: '/adv/list',
        name: 'AdvList',
        meta: {
          title: '广告位',
        },
        component: () => import('../views/adv/List'),
      },
      {
        path: '/notice/list',
        name: 'NoticeList',
        meta: {
          title: '公告列表',
        },
        component: () => import('../views/notice/List'),
      },
      {
        path: '/notice/add',
        name: 'NoticeAdd',
        meta: {
          title: '新增公告',
        },
        component: () => import('../views/notice/Add'),
      },
      {
        path: '/notice/edit',
        name: 'NoticeEdit',
        meta: {
          title: '编辑公告',
        },
        component: () => import('../views/notice/Edit'),
      },
      {
        path: '/notice/detail',
        name: 'NoticeDetail',
        meta: {
          title: '查看公告',
        },
        component: () => import('../views/notice/Detail'),
      },
      {
        path: '/faq/list',
        name: 'FAQList',
        meta: {
          title: '常见问题',
        },
        component: () => import('../views/faq/List'),
      },
      {
        path: '/faq/edit',
        name: 'FAQEdit',
        meta: {
          title: '编辑常见问题',
        },
        component: () => import('../views/faq/Edit'),
      },
      {
        path: '/faq/detail',
        name: 'FAQDetail',
        meta: {
          title: '查看常见问题',
        },
        component: () => import('../views/faq/Detail'),
      },
      {
        path: '/suggest/list',
        name: 'SuggestList',
        meta: {
          title: '建议收集',
        },
        component: () => import('../views/suggest/List'),
      },
      {
        path: '/suggest/edit',
        name: 'SuggestEdit',
        meta: {
          title: '查看/编辑建议',
        },
        component: () => import('../views/suggest/Edit'),
      },
      {
        path: '/report/list',
        name: 'ReportList',
        meta: {
          title: '举报管理',
          keepAlive: true,
          keepAliveList: [],
        },
        component: () => import('../views/report/List'),
      },
      {
        path: '/apk/list',
        name: 'ApkList',
        meta: {
          title: '安装包管理',
        },
        component: () => import('../views/apk/List'),
      },
      {
        path: '/rich-text/list',
        name: 'RichTextList',
        meta: {
          title: '富文本管理',
        },
        component: () => import('../views/rich-text/List'),
      },
      {
        path: '/rich-text/add',
        name: 'RichTextAdd',
        meta: {
          title: '新增文本协议',
        },
        component: () => import('../views/rich-text/Add'),
      },
      {
        path: '/rich-text/edit',
        name: 'RichTextEdit',
        meta: {
          title: '编辑文本协议',
        },
        component: () => import('../views/rich-text/Edit'),
      },
      {
        path: '/rich-text/detail',
        name: 'RichTextDetail',
        meta: {
          title: '查看文本协议',
        },
        component: () => import('../views/rich-text/Detail'),
      },
      {
        path: '/award/list',
        name: 'AwardList',
        meta: {
          title: '打赏管理',
        },
        component: () => import('../views/award/List'),
      },
      {
        path: '/hardware/list',
        name: 'HardwareList',
        meta: {
          title: '硬件设置',
          keepAlive: true,
          keepAliveList: []
        },
        component: () => import('../views/hardware/List'),
      },
      {
        path: '/hardware/export',
        name: 'HardwareExport',
        meta: {
          title: '硬件设置-批量导出',
        },
        component: () => import('../views/hardware/Export'),
      },
      {
        path: '/hardware-manage/list',
        name: 'HardwareManageList',
        meta: {
          title: '智能硬件管理',
          keepAlive: false,
          keepAliveList: []
        },
        component: () => import('../views/hardware-manage/List'),
      },
      {
        path: '/hardware-manage/add',
        name: 'HardwareManageAdd',
        meta: {
          title: '新增硬件',
          keepAliveList: []
        },
        component: () => import('../views/hardware-manage/Add'),
      },
      {
        path: '/hardware-manage/edit',
        name: 'HardwareManageEdit',
        meta: {
          title: '编辑硬件',
          keepAliveList: []
        },
        component: () => import('../views/hardware-manage/Edit'),
      },
      {
        path: '/hardware-manage/export',
        name: 'HardwareManageExport',
        meta: {
          title: '智能硬件批量导出',
        },
        component: () => import('../views/hardware-manage/Export'),
      },
      {
        path: '/rice/list',
        name: 'RiceList',
        meta: {
          title: '煮米模式',
        },
        component: () => import('../views/rice/List'),
      },
      {
        path: '/rice-tip/list',
        name: 'RiceTipEdit',
        meta: {
          title: '小贴士',
        },
        component: () => import('../views/rice-tip/Edit'),
      },
      {
        path: '/curve/list',
        name: 'CurveList',
        meta: {
          title: '曲线图模式（弃用）',
        },
        component: () => import('../views/curve/List'),
      },
      {
        path: '/part-sound/list',
        name: 'PatSoundList',
        meta: {
          title: '区间声音设置',
        },
        component: () => import('../views/part-sound/List'),
      },
      {
        path: '/record/list',
        name: 'RecordList',
        meta: {
          title: '记录模式管理（弃用）',
        },
        component: () => import('../views/record/List'),
      },
      {
        path: '/geo-adjust/list',
        name: 'GeoAdjustList',
        meta: {
          title: '经纬度校正管理',
        },
        component: () => import('../views/geo-adjust/List'),
      },
      {
        path: '/geo-adjust/areaList',
        name: 'AreaList',
        meta: {
          title: '使用区域对应',
        },
        component: () => import('../views/geo-adjust/AreaList'),
      },
      {
        path: '/weigh-cal/list',
        name: 'WeighCalList',
        meta: {
          title: '砝码校正管理（弃用）',
        },
        component: () => import('../views/weigh-cal/List'),
      },
      {
        path: '/unit/list',
        name: 'UnitList',
        meta: {
          title: '智能单位管理',
        },
        component: () => import('../views/unit/List'),
      },
      {
        path: '/unit/add',
        name: 'UnitAdd',
        meta: {
          title: '新增智能单位',
        },
        component: () => import('../views/unit/Add'),
      },
      {
        path: '/unit/edit',
        name: 'UnitEdit',
        meta: {
          title: '编辑智能单位',
        },
        component: () => import('../views/unit/Edit'),
      },
      {
        path: '/lang/list',
        name: 'LangList',
        meta: {
          title: '地区语言设置',
        },
        component: () => import('../views/lang/List'),
      },
      {
        path: '/lang/add',
        name: 'LangAdd',
        meta: {
          title: '新增地区语言设置',
        },
        component: () => import('../views/lang/Add'),
      },
      {
        path: '/lang/edit',
        name: 'LangEdit',
        meta: {
          title: '编辑地区语言设置',
        },
        component: () => import('../views/lang/Edit'),
      },
      {
        path: '/recommend/list',
        name: 'RecommendList',
        meta: {
          title: '推荐值',
        },
        component: () => import('../views/recommend/List.vue'),
      },
      {
        path: '/recommend/edit',
        name: 'RecommendEdit',
        meta: {
          title: '推荐值编辑',
        },
        component: () => import('../views/recommend/Edit.vue'),
      },
      {
        path: '/mac-code/list',
        name: 'MacList',
        meta: {
          title: '蓝牙Mac码列表',
        },
        component: () => import('../views/mac-code/List.vue'),
      },
      {
        path: '/log/list',
        name: 'logList',
        meta: {
          title: '台账日志',
        },
        component: () => import('../views/log/List.vue'),
      },
      {
        path: '/test',
        name: 'test',
        meta: {
          title: '测试',
        },
        component: () => import('../views/test/Test.vue'),
      },
      {
        path: '/landing-page/list',
        name: 'LandingPageList',
        meta: {
          title: '引导页',
        },
        component:()=>import("../views/landing-page/List.vue")
      },
      {
        path: "/url-schemes",
        name: "UrlSchemes",
        meta: {
          title: "URL Schemes",
        },
        component: () => import("../views/url-schemes/ankn-url-schemes.vue"),
      },
      {
        path: "/area-ata/list",
        name: "AreaDataList",
        meta: {
          title: "地区服务器",
        },
        component: () => import("../views/area-data/List.vue"),
      },
      {
        path: "/use-area/list",
        name: "UseAreaList",
        meta: {
          title: "使用地区",
        },
        component: () => import("../views/use-area/List.vue"),
      },
      {

        path: '/user-manager/list',
        name: 'user-manager-list',
        meta: {title: '用户列表', tab: true},
        component: () => import(/* webpackChunkName: "views" */ '../views/user-manager/List'),
      },
      {

        path: '/user-manager/add',
        name: 'user-manager-add',
        meta: {title: '新增用户', tab: true},
        component: () => import(/* webpackChunkName: "views" */ '../views/user-manager/Add'),
      },
      {
        path: '/user-manager/edit',
        name: 'user-manager-edit',
        meta: {title: '编辑用户', tab: true},
        component: () => import(/* webpackChunkName: "views" */ '../views/user-manager/Edit'),
      },
      {
        path: '/pay-fee/list',
        name: 'pay-fee-list',
        meta: {title: '抽佣配置', tab: true},
        component: () => import(/* webpackChunkName: "views" */ '../views/pay-fee/List.vue'),
      },
      {
        path: '/el-flag/list',
        name: 'ElFlagList',
        meta: {title: '总元素库', tab: true},
        component: () => import(/* webpackChunkName: "views" */ '../views/el-flag/List.vue'),
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {title: '登录', tab: true},
    component: () => import('../views/login/Login'),
  },
];
